import {
  providerStatus,
  paymentMethods as paymentMethodsEnum,
  transfersArray,
  civilStateEnum,
} from '../helpers/options';
import { notify } from './toast';
import {
  particularServices,
  afiliatedServices,
  statusHeadervalues,
  salesMembershipStatus,
  planStatus,
  planTypes,
  LANDING,
  PagoMovilArray,
  IGTFVALUE,
  paymentMethods,
  vehiclesEnum,
  vehicleUsageOptions,
  vehicleUsageEnum,
  rcvEnum,
  requiredLengthRefMethods,
  paymentType,
  PMandTransfers,
  transactionTypes,
} from './options';
import { salesRoles } from '../helpers/roles';
import * as XLSX from 'xlsx';
import moment from 'moment';
import authService from '../../services/authService';
import { dataParse } from './parsers';
import {
  paymentRefMinLength,
  maxPercentageBelowDiffAllowed,
  maxPercentageOverDiffAllowed,
} from '../helpers/variables';

export const convertRCVNameToId = (rcv, rcvOptions) => {
  let option = rcvOptions?.filter((r) => r?.name === rcv);
  let response = option[0]?.mongoId;
  return response;
};

export const renameMembreshipCrossStatus = (name) => {
  if (name === planStatus?.TO_BE_EXPIRED) {
    return 'Vencido';
  }
  if (name === planStatus?.EXPIRED) {
    return 'Rescate';
  } else {
    return name;
  }
};

export const convertToHyphenatedLowerCase = (phrase) => {
  let url = phrase.toLowerCase().replace(/\s+/g, '-');
  return url;
};

export const rename = (str) => {
  if (str) {
    if (typeof str === 'number') {
      str = str.toString();
    }
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();

    // remove accents, swap ñ for n, etc
    var from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;';
    var to = 'aaaaeeeeiiiioooouuuunc------';
    for (var i = 0, l = from.length; i < l; i++) {
      str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str
      .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
      .replace(/\s+/g, '-') // collapse whitespace and replace by -
      .replace(/-+/g, '-'); // collapse dashes

    return str;
  }
};

export const currencyFormat = (value) => {
  if (!value && value != 0) {
    return '';
  }

  return '$' + value.toLocaleString('es');

  // value = Number(value).toFixed(2);
  // if (value < 0) {
  //   value = value * -1;
  //   return '-$' + value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  // } else {
  //   return '$' + value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  // }
};

const maskedMembershipCodes = {
  [planTypes?.GOLDM]: planTypes?.GOLD,
  [planTypes?.PLUSM]: planTypes?.PLUS,
  [planTypes?.CLASSICM]: planTypes?.CLASSIC,
};

export const displayMembershipCode = (code) => {
  return maskedMembershipCodes[code] || code;
};

export const capitalize = (str) => {
  if (str) {
    if (typeof str === 'number') {
      str = str.toString();
    }

    str = str?.toLowerCase();
    const arr = str.split(' ');
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    let str2 = arr.join(' ');
    str2 = str2.replace(/rcv/gi, 'RCV');

    return str2;
  } else return '';
};

export const NaNtoNumber = (value) => {
  if (!value || undefined) {
    return 0;
  } else {
    return value;
  }
};

export const translateStatus = (str) => {
  if (str === providerStatus.available) {
    return 'Disponible';
  }
  if (str === providerStatus.busy) {
    return 'Ocupado';
  } else {
    return '';
  }
};

export const exists = (str) => {
  if (str && ![null, NaN, 'NaN']?.includes(str)) {
    return str;
  } else return '';
};

export function format(inputDate) {
  if (inputDate) {
    // expects Y-m-d
    var splitDate = inputDate.split('-');
    if (splitDate.count == 0) {
      return null;
    }

    var year = splitDate[0];
    var month = splitDate[1];
    var day = splitDate[2];

    return day + '/' + month + '/' + year;
  }
}

export const fixResponseJSON = async (response) => {
  let rullResp = await response.json();
  rullResp.status = response.status;
  return rullResp;
};

export const filterParams = (params) => {
  for (const key in params) {
    if (
      params[key] === undefined ||
      params[key] === null ||
      params[key] === ''
    ) {
      delete params[key];
    }
  }
  return params;
};

// Function that checks if the case time has expired or soon to be and sends a notification
export const checkAlert = (caso) => {
  let start = new Date(caso?.lastStage?.createdAt);
  let now = new Date();
  var diff = now.getTime() - start.getTime(); // This will give difference in milliseconds
  diff = Math.round(diff / 60000);
  if (
    diff > parseInt(process.env.REACT_APP_ALERT_TIME) &&
    diff < parseInt(process.env.REACT_APP_WARNING_TIME)
  ) {
    notify(
      `${caso?.status}: ${caso?.caseId} de ${capitalize(
        caso?.membership?.customer?.firstName ||
          caso?.particularCustomer?.firstName
      )} ${capitalize(
        caso?.membership?.customer?.lastName ||
          caso?.particularCustomer?.lastName
      )} tiene ${diff} minutos sin ser atendida `,
      'success'
    );
    return 'reminder';
  }

  if (diff > parseInt(process.env.REACT_APP_WARNING_TIME)) {
    notify(
      `${caso?.status}: ${caso?.caseId} de ${capitalize(
        caso?.membership?.customer?.firstName ||
          caso?.particularCustomer?.firstName
      )} ${capitalize(
        caso?.membership?.customer?.lastName ||
          caso?.particularCustomer?.lastName
      )} tiene ${diff} minutos sin ser atendida `,
      'error'
    );
    return 'warning';
  }
};
export const formattedNumber = (x) => {
  return x.toFixed(2).replace(/[.,]00$/, '');
};

// Function that checks if the case time has expired or soon to be
export const checkCardTime = (caso) => {
  let start = new Date(caso?.lastStage?.createdAt);
  let now = new Date();
  var diff = now.getTime() - start.getTime(); // This will give difference in milliseconds
  diff = Math.round(diff / 60000);
  if (
    diff > parseInt(process.env.REACT_APP_ALERT_TIME) &&
    diff < parseInt(process.env.REACT_APP_WARNING_TIME)
  ) {
    return 'reminder';
  }

  if (diff > parseInt(process.env.REACT_APP_WARNING_TIME)) {
    return 'warning';
  }
};
// Function that checks if the cases have expired or soon to be and paints the card
export let paintCard = (casos) => {
  let alert = '';

  for (let i = 0; i < casos?.length; i++) {
    if (checkCardTime(casos[i]) === 'reminder' && alert !== 'warning') {
      alert = checkCardTime(casos[i]);
    }
    if (checkCardTime(casos[i]) === 'warning') {
      alert = checkCardTime(casos[i]);
    }
  }
  return alert;
};

export const checkFilterAndWarn = (casos, status) => {
  let filteredCases = casos?.filter((c) => c.status === status);
  for (let i = 0; i < filteredCases.length; i++) {
    checkAlert(filteredCases[i]);
  }
  return filteredCases;
};

export const serviceName = (code) => {
  if ([afiliatedServices.crane, particularServices.crane].includes(code)) {
    return 'Grúa';
  }
  if ([afiliatedServices.gas, particularServices.gas].includes(code)) {
    return 'Aux Gasol';
  }
  if ([afiliatedServices.accompaniment].includes(code)) {
    return 'AV';
  }
  if ([afiliatedServices.battery, particularServices.battery].includes(code)) {
    return 'Aux Bateria';
  }
  if ([afiliatedServices.tire, particularServices.tire2].includes(code)) {
    return 'Cambio Caucho';
  }
  if ([particularServices.tire1].includes(code)) {
    return 'Inflado Caucho';
  } else {
    return code;
  }
};

export const reasignTime = (data, index) => {
  let totalTime = 0;
  for (let j = 0; j < data?.newStages.length; j++) {
    if (data?.stages[j]?.name === data?.newStages[index]?.name) {
      return (data?.stages[j]?.totalTime / 60).toFixed(2) + ' min';
    }

    if (index === data?.newStages.length - 1) {
      for (let i = 0; i < data?.stages.length; i++) {
        if (statusHeadervalues.includes(data?.stages[i]?.name)) {
          totalTime = totalTime + data?.stages[i]?.totalTime;
        }
      }
      totalTime = (totalTime / 60).toFixed(2);
      return totalTime > 0 ? totalTime + ' min' : '';
    }
  }
};

export const clearObject = (params) => {
  for (const key in params) {
    if (params[key] === undefined || params[key] == '') {
      if (params[key] !== false) {
        delete params[key];
      }
    }
  }
  return params;
};

export const renameMembershipStatus = (status) => {
  let res = '';

  switch (status) {
    case salesMembershipStatus?.ACTIVO:
      res = 'Activa';
      break;
    case salesMembershipStatus?.POR_RENOVACION:
      res = 'Por Renovación';
      break;
    case salesMembershipStatus?.POR_VENCER:
      res = 'Vencidas (Período de Salva)';
      break;
    case salesMembershipStatus?.VENCIDO:
      res = 'Perdidas';
      break;
    case salesMembershipStatus?.ANULADO:
      res = 'Anulados';
      break;
    case 'PENDIENTE DE APROBACION':
      res = 'Por Aprobacion';
      break;
    case salesMembershipStatus?.INCOMPLETO:
      res = 'Incompleta';
      break;
    default:
      res = status;
      break;
  }
  return res;
};

export const filterAndMapPlans = (array) => {
  const filterArray = array.filter((obj, index) => {
    return index === array.findIndex((o) => obj.rcv === o.rcv);
  });
  return filterArray;
};

export const getPrevMonth = (month, monthsBefore) => {
  month = month - monthsBefore;
  if (month < 0) {
    month = month + 12;
  }
  return month;
};

export const getNextMonth = (month, monthsAfter) => {
  month = month + monthsAfter;
  if (month > 11) {
    month = month - 12;
  }
  return month;
};

export const MethodValidation = (payments, fileUploaded, paymentMethods) => {
  let method = paymentMethods?.filter((p) =>
    [paymentMethodsEnum?.PUNTO_DE_VENTA, paymentMethodsEnum?.TDC]?.includes(
      p.name
    )
  );

  let PDVCounter = 0;
  let regulayPayments = payments?.length;
  for (let i = 0; i < payments?.length; i++) {
    if ([method[0]?._id, method[1]?._id]?.includes(payments[i].method)) {
      PDVCounter = PDVCounter + 1;
    }
  }

  regulayPayments = regulayPayments - PDVCounter;

  if (regulayPayments > 0 && regulayPayments !== fileUploaded?.length) {
    return true;
  } else return false;
};

export const checkMissingVehicleFields = (membership) => {
  const {
    address,
    brand,
    city,
    model,
    state,
    type,
    plate,
    year,
    municipality,
    class: clase,
  } = membership?.vehicle;

  if (
    !brand ||
    !model ||
    !type ||
    !plate ||
    !year ||
    !state ||
    !city ||
    !address ||
    !municipality ||
    !clase
  ) {
    return '#ff6666';
  } else {
    return null;
  }
};

export const checkMissingVehicleFieldsSales = (membership) => {
  const {
    address,
    brand,
    city,
    model,
    state,
    type,
    plate,
    year,
    municipality,
    class: clase,
  } = membership?.vehicle;

  if (
    !brand ||
    !model ||
    !type ||
    !plate ||
    !year ||
    !state ||
    !city ||
    !address ||
    !municipality ||
    !clase
  ) {
    return true;
  } else {
    return false;
  }
};

export const returnMissingFields = (array, object) => {
  let missingFields = [];

  for (let i = 0; i < array.length; i++) {
    if (
      !object.hasOwnProperty(array[i]?.label) ||
      object[array[i]?.label] === '' ||
      object[array[i]?.label] === null ||
      object[array[i]?.label] === undefined
    ) {
      missingFields.push(array[i]);
    }
  }

  return missingFields;
};

export const getCorrectDate = (date) => {
  if (!date) return null;

  // let d = new Date(date);
  let d = new Date(date);
  d = new Date(d.getTime());

  if (isNaN(d.getTime())) {
    return null;
  }

  return d;
};

export const exportDataToExcel = (DATA, fileName) => {
  // Convert the data to CSV format using PapaParse
  let ws = XLSX.utils.json_to_sheet(DATA);
  let wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'sheet');
  XLSX.writeFile(wb, fileName);
};

export const filterSatesMotoriderAV = (states) => {
  states = states.filter((s) =>
    ['DISTRITO CAPITAL', 'MIRANDA', 'ANZOÁTEGUI', 'CARABOBO']?.includes(s?.name)
  );
  return states;
};

export const removeBlankSpacesAndUppercase = (data, name, setValue) => {
  data = data.replace(/\s/g, '');
  setValue(name, data?.toUpperCase());
};

export const removeSpecialCharsAndUppercase = (data, name, setValue) => {
  data = data.replace(/[^a-zA-Z0-9]/g, '');
  setValue(name, data?.toUpperCase());
};

export const defineLangindType = (params, membership) => {
  if (
    [planTypes?.PLUSF4]?.includes(membership?.membershipPlan) &&
    ![
      planStatus?.PENDING_FOR_APPROBAL,
      planStatus?.TO_BE_RENEW,
      planStatus?.EXPIRED,
    ]?.includes(membership?.membershipStatus)
  ) {
    params.landing = LANDING?.PRIVATE;
  }

  if (
    [planTypes?.PLUSF4, planTypes?.F2, planTypes?.GOLDENP]?.includes(
      membership?.membershipPlan
    ) &&
    [
      planStatus?.ACTIVE,
      planStatus?.PENDING_FOR_APPROBAL,
      planStatus?.TO_BE_RENEW,
      planStatus?.EXPIRED,
      planStatus?.WAITING,
    ]?.includes(membership?.membershipStatus)
  ) {
    params.landing = LANDING?.MARKETING;
  }

  if ([planTypes?.MOTORIDERAV]?.includes(membership?.membershipPlan)) {
    params.landing = LANDING?.PRIVATE;
  }
  return params;
};

export const greatedThanDate = (date1, date2) => {
  const d1 = new Date(date1);
  const d2 = new Date(date2);
  return d1.getTime() > d2.getTime();
};

export const validateIfOther = (watch, options) => {
  const other = options?.filter((o) => o?._id === watch('economicActivity'));
  if ([other[0]?.name]?.includes('Otro')) {
    return true;
  } else return false;
};

export const getMonthInSpanish = (date) => {
  if (!date) return null;
  const fecha = new Date(date);
  const months = [
    'enero',
    'febrero',
    'marzo',
    'abril',
    'mayo',
    'junio',
    'julio',
    'agosto',
    'septiembre',
    'octubre',
    'noviembre',
    'diciembre',
  ];
  const monthIndex = fecha?.getMonth();
  return capitalize(months[monthIndex]);
};

export const filterOption = (options, name) => {
  const [selected] = options?.filter((o) => o?.name === name);
  return selected || '';
};

export const filterOptionByName = (options, name) => {
  let formattedName = name?.toLowerCase()?.trim();
  const [selected] = options?.filter(
    (o) => o?.name?.toLowerCase()?.trim() === formattedName
  );
  return selected || '';
};

export const filterById = (options, _id) => {
  const [selected] = options?.filter((o) => o?._id === _id);
  return selected || '';
};

export const filterOptionById = (options, _id) => {
  if (options) {
    const [selected] = options?.filter((o) => [o?._id, o?.id].includes(_id));
    return selected || '';
  }
};

export const displayChange = (data, param, source) => {
  if (validateIfDate(data?.[source])) {
    return moment(data?.[source]).format('DD/MM/YYYY');
  }

  if (typeof data?.[source] === 'number') {
    return data?.[source].toLocaleString('es');
  }
  if (typeof data?.[source] === 'boolean' && data?.[source]) {
    return data?.[source] ? 'Si' : 'No';
  }

  const value = data?.[source];
  if (!value || (Array.isArray(value) && value.length === 0)) {
    return ' ';
  }
  if (Array.isArray(value)) {
    return value.map((item) => item?.label || item).join('\n');
  }

  if (param === 'priceInfo') {
    // Si existe y es objeto, retorna el parseo
    if (data?.[source] && typeof data?.[source] === 'object') {
      return dataParse(data?.[source]);
    }
    // Si no existe, retorna vacío o mensaje
    return '';
  }
  if (typeof data?.[source] === 'object' && data?.[source] !== null) {
    return data?.[source]?.label;
  }

  // if number

  // if type is Array return all elements.label joined by line break
  if (Array.isArray(data?.[source])) {
    return data?.[source].map((item) => item?.label || item).join(', ');
  } else return data?.[source];
};

export const validateIfDate = (input) => {
  const dateRegex1 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/;
  const dateRegex2 =
    /^\w{3} \w{3} \d{2} \d{4} \d{2}:\d{2}:\d{2} GMT[-+]\d{4} \(\w+ Time\)$/;

  if (dateRegex1.test(input) || dateRegex2.test(input)) {
    return true;
  } else {
    return false;
  }
};

export const validateIfShowPM = (options, method) => {
  let filteredOptions = options?.filter((o) =>
    PagoMovilArray?.includes(o?.name)
  );
  if (filteredOptions.some((option) => option._id === method)) {
    return true;
  } else {
    return false;
  }
};

export const validateIfShowTransferFields = (options, method) => {
  let filteredOptions = options?.filter((o) =>
    transfersArray?.includes(o?.name)
  );
  if (filteredOptions.some((option) => option._id === method)) {
    return true;
  } else {
    return false;
  }
};

export function formatCurrency(number) {
  if (!number) {
    return '';
  }
  const parts = number.toString().split('.');
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const decimalPart = parts[1] || '';

  return integerPart + (decimalPart ? `.${decimalPart}` : '');
}

export const validateAndSet = (name, value, set, watch) => {
  // Si el valor es una instancia de Date, verifica si es una fecha válida.
  if (value instanceof Date && !isNaN(value)) {
    set(name, value);
  } else if (!(value instanceof Date) && value) {
    // Para otros tipos de valores, solo verifica que no sea falsy.
    set(name, value);
  }
};

export const returnIGTF = () => {
  let user = authService?.getUser();
  if (user) {
    return 0;
  } else {
    return IGTFVALUE;
  }
};

export const isPaymentMethodZelleOrPaypal = (payment, paymentOptions) => {
  const paymentOption = paymentOptions.find((option) => option._id === payment);
  return (
    paymentOption &&
    [
      paymentMethods.VENPAY,
      paymentMethods.ZELLE,
      paymentMethods.PAYPAL,
    ].includes(paymentOption.name)
  );
};

export const getDuefromSuccessPayments = (membership) => {
  const { payments, priceInfo } = membership;

  let due = 0;

  if (payments.length > 0) {
    // sum all payment.totalAmount from payments array toFixed(2)
    let totalPaid = payments.reduce((acc, payment) => {
      return acc + payment.totalAmount;
    }, 0);

    // subtract totalPaid from priceInfo.finalPrice toFixed(2)
    due = priceInfo?.finalPrice - totalPaid;

    return due.toFixed(2);
  }

  return priceInfo?.finalPrice;
};

export const sumTotal = (watch, name, quantity) => {
  let total = 0;
  for (let i = 0; i < parseFloat(quantity); i++) {
    total = total + parseFloat(watch(`${name}${i}`));
    NaNtoNumber(total);
  }

  if (total || total === 0) {
    return parseFloat(total.toFixed(2));
  } else return 0;
};

export const parseUrl = (url) => {
  if (url) {
    return url.toLowerCase().replace(/\s+/g, '-');
  }
  return '';
};

export const reverseParse = (str) => {
  if (str) {
    str = str.charAt(0).toUpperCase() + str.slice(1);
    return str.replace(/-/g, ' ');
  }
  return '';
};
export const OtpValidation = (otp) => {
  const otpLength = 8;
  const otpRegex = /^[a-zA-Z0-9]*$/;
  // otp need to be alphanumeric and 8 characters long
  if (otp.length === otpLength && otpRegex.test(otp)) {
    return true;
  } else {
    return false;
  }
};

export const disableCopyAndContextMenu = (elementRef) => {
  if (!elementRef?.current) return;

  const element = elementRef.current;

  // Manejar "Ctrl + C"
  const handleKeyDown = (e) => {
    if (e.ctrlKey && e.key === 'c') {
      e.preventDefault();
      // alert('Copiar está deshabilitado en esta tabla.');
    }
  };

  // Manejar el menú contextual (clic derecho)
  const handleContextMenu = (e) => {
    e.preventDefault();
    // alert('La opción de copiar está deshabilitada en esta tabla.');
  };

  document.addEventListener('keydown', handleKeyDown);
  element.addEventListener('contextmenu', handleContextMenu);

  // Limpiar eventos al desmontar
  return () => {
    document.removeEventListener('keydown', handleKeyDown);
    element.removeEventListener('contextmenu', handleContextMenu);
  };
};

export const disableJustCopy = (elementRef) => {
  if (!elementRef?.current) return;

  const element = elementRef.current;

  // Manejar "Ctrl + C"
  const handleKeyDown = (e) => {
    if (e.ctrlKey && e.key === 'c') {
      e.preventDefault();
      // alert('Copiar está deshabilitado en esta tabla.');
    }
  };

  document.addEventListener('keydown', handleKeyDown);

  // Limpiar eventos al desmontar
  return () => {
    document.removeEventListener('keydown', handleKeyDown);
  };
};

export const handleContextMenu = (e, options) => {
  const targetCell = e.target.closest('td[data-column]');

  if (targetCell) {
    const columnValue = targetCell.getAttribute('data-column');

    if (!options.includes(columnValue)) {
      e.preventDefault();
    }
  } else {
    e.preventDefault();
  }
};

export const copyClipboard = async (data, type) => {
  let clippedText = '';

  switch (type) {
    case 'pending':
      if (navigator && navigator.clipboard) {
        try {
          clippedText = data?.membershipId ? `${data?.membershipId}` : '';
          await navigator.clipboard.writeText(clippedText);
          notify(`Copiado al portapapeles`, 'success');
        } catch (err) {
          notify(`Error al copiar al portapapeles`, 'error');
        }
      } else {
        console.log(
          'navigator.clipboard no está disponible en este navegador.'
        );
      }

      break;
    case 'renewal':
      if (navigator && navigator.clipboard) {
        try {
          clippedText =
            data?.vehicle?.plate && data?.vehicle?.model
              ? `${data?.vehicle?.plate.toUpperCase()} ${capitalize(
                  data?.vehicle?.model
                )}`
              : '';
          await navigator.clipboard.writeText(clippedText);
          notify(`Copiado al portapapeles`, 'success');
        } catch (err) {
          console.error('Error al copiar al portapapeles:', err);
          notify(`Error al copiar al portapapeles`, 'error');
        }
      } else {
        console.log(
          'navigator.clipboard no está disponible en este navegador.'
        );
      }
      break;
    default:
      break;
  }
};

export const convertToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export const convertBase64ToFile = (base64, fileName, mimeType) => {
  const byteString = atob(base64.split(',')[1]);
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const uint8Array = new Uint8Array(arrayBuffer);

  for (let i = 0; i < byteString.length; i++) {
    uint8Array[i] = byteString.charCodeAt(i);
  }

  return new File([uint8Array], fileName, { type: mimeType });
};

export const filterVehicleUse = (vehicle, vehicleClassesOptions) => {
  if (!vehicle || !vehicleClassesOptions) {
    return [];
  }

  const _class = filterById(
    vehicleClassesOptions,
    vehicle.memToRenew.vehicle.class
  );
  let opciones = [];
  if ([vehiclesEnum?.AUTOMOVIL, vehiclesEnum?.RUSTICO].includes(_class.name)) {
    opciones = vehicleUsageOptions?.filter((option) =>
      [vehicleUsageEnum.PUBLIC, vehicleUsageEnum.PARTICULAR].includes(
        option?._id
      )
    );
  }

  if ([vehiclesEnum?.AUTOBUS, vehiclesEnum?.MINIBUS].includes(_class.name)) {
    opciones = vehicleUsageOptions?.filter((option) =>
      [vehicleUsageEnum.PUBLIC].includes(option?._id)
    );
  }

  if ([vehiclesEnum?.CAMIONETA].includes(_class.name)) {
    opciones = vehicleUsageOptions?.filter((option) =>
      [
        vehicleUsageEnum.PUBLIC,
        vehicleUsageEnum.PARTICULAR,
        vehicleUsageEnum.LOAD,
      ].includes(option?._id)
    );
  }

  if ([vehiclesEnum?.MOTO].includes(_class.name)) {
    opciones = vehicleUsageOptions?.filter((option) =>
      [vehicleUsageEnum.LOAD, vehicleUsageEnum.PARTICULAR].includes(option?._id)
    );
  }
  if ([vehiclesEnum?.TRIMOTO].includes(_class.name)) {
    opciones = vehicleUsageOptions?.filter((option) =>
      [vehicleUsageEnum.LOAD].includes(option?._id)
    );
  }
  if (
    [
      vehiclesEnum?.CAMION,
      vehiclesEnum?.AMBULANCIA,
      vehiclesEnum?.GRUA,
    ].includes(_class.name)
  ) {
    opciones = vehicleUsageOptions?.filter((option) =>
      [vehicleUsageEnum.LOAD].includes(option?._id)
    );
  }

  return opciones;
};

export const validateRCVData = (membership) => {
  if (
    membership.rcv !== rcvEnum.NA &&
    (!membership.vehicleData.bodySerial ||
      !membership.vehicleData.engineSerial ||
      !membership.vehicleData.seats ||
      !membership.vehicleData.vehicleUsage ||
      !membership.customer.economicActivity ||
      !membership.customer.profession ||
      !membership.vehicleData.titleNumber)
  ) {
    return false;
  }
  return true;
};

export const generateRandomKey = (objectId, str) => {
  objectId = objectId.split('');
  str = str.split('');
  const randomKey = [];

  while (objectId.length > 0 && str.length > 0) {
    const randomChoice = Math.random();
    if (objectId.length > 0 && (str.length === 0 || randomChoice < 0.5)) {
      randomKey.push(objectId.shift());
    } else if (str.length > 0) {
      randomKey.push(str.shift());
    } else {
      break;
    }
  }
  return randomKey.join('');
};

export const validateReferenceLength = (method, payment) => {
  if (
    requiredLengthRefMethods.includes(method?.name) &&
    payment?.reference?.length < paymentRefMinLength
  ) {
    notify(
      `La referencia debe tener un minimo de ${paymentRefMinLength} digitos`,
      'info'
    );
    return false;
  } else {
    return true;
  }
};

export const validateUpdatePaymentRefLenght = (
  data,
  setError,
  paymentMethodsOptions
) => {
  let isValid = true;

  let option = '';

  option = filterOptionById(paymentMethodsOptions, data?.method);
  if (
    requiredLengthRefMethods?.includes(option?.name) &&
    data?.reference?.length < paymentRefMinLength
  ) {
    setError(`reference`, {
      type: 'manual',
      message: `La referencia debe tener un minimo de ${paymentRefMinLength} digitos`,
    });
    isValid = false;
  }
  return isValid;
};

export const validatePaymentDifference = (accumulatedAmount, billAmount) => {
  if (!billAmount || billAmount === 0) return false;

  const ratio = ((accumulatedAmount - billAmount) / billAmount) * 100; // positive => over, negative => below

  if (ratio < 0) {
    // below price
    return Math.abs(ratio) <= maxPercentageBelowDiffAllowed;
  } else {
    // over price
    return ratio <= maxPercentageOverDiffAllowed;
  }
};

export const amountValdiationMessage = (total, billAmount) => {
  if (!billAmount || billAmount === 0) return '';

  const ratio = ((total - billAmount) / billAmount) * 100; // positive => over, negative => below
  const belowMaxAmount = (
    (billAmount * maxPercentageBelowDiffAllowed) /
    100
  ).toFixed(2);
  const overMaxAmount = (
    (billAmount * maxPercentageOverDiffAllowed) /
    100
  ).toFixed(2);

  if (ratio < 0 && Math.abs(ratio) > maxPercentageBelowDiffAllowed) {
    return `La diferencia permitida debe ser de máximo ${belowMaxAmount}$ por debajo`;
  }

  if (ratio > 0 && ratio > maxPercentageOverDiffAllowed) {
    return `La diferencia permitida debe ser de máximo ${overMaxAmount}$ por encima`;
  }
  return '';
};

export const sortPublicPaymentMethods = (paymentMethods) => {
  const priorityIds = [
    '656976f61d4975ed691d30e2', // PM Bancamiga
    '656974241d4975ed691d30e0', // Trasnferencia BM
    '6824ff3c748321f6426d3b53', // C2P Bancamiga
    '6888e12f6f204b68c26c4d96', // Humaniz
    '646955f7fccc5f07cd2b8d48', // Zelle
    '646955f7fccc5f07cd2b8d56', // Binance
    '646955f7fccc5f07cd2b8d54', // Paypal
    '646955f7fccc5f07cd2b8d4a', // TDC Nacional
  ];
  const uniquePriority = Array.from(new Set(priorityIds));

  if (!Array.isArray(paymentMethods)) return [];

  const list = paymentMethods.slice();

  // Collect priority items in the specified order (keeping duplicates from list if any)
  const priorityItems = [];
  uniquePriority.forEach((id) => {
    for (const pm of list) {
      const pmId = pm?._id ?? pm?.id;
      if (pmId === id) priorityItems.push(pm);
    }
  });

  // Append the rest preserving original order
  const prioritySet = new Set(uniquePriority);
  const rest = list.filter((pm) => !prioritySet.has(pm?._id ?? pm?.id));

  let aver = [...priorityItems, ...rest];

  return aver;
};

export const filterRCVOptions = (options) => {
  return options.filter(
    (opt) => !['RCV Básico', rcvEnum?.RCV_BASIC]?.includes(opt?.name)
  );
};

export const checkNumValue = (value) => {
  if (isNaN(value) || value === null || value === undefined) {
    return 0;
  } else {
    return value;
  }
};

export const validateGiftcardPaymentTypes = (options) => {
  if (window.location.pathname.includes('giftcard')) {
    options = options.filter(
      (o) => ![paymentType?.FINANCIADO, paymentType?.PENDING]?.includes(o?._id)
    );
  }

  return options;
};

export const validateIfHasPublicCodes = (watch) => {
  const count = parseInt(watch('soldCardsCount') || 0);
  for (let i = 0; i < count; i++) {
    if (
      !watch(`publicCode${i}`) ||
      !watch(`vehicleClass${i}`) ||
      !watch(`vehicleYear${i}`) ||
      // !watch(`vehicleIsArmored${i}`) ||
      !watch(`rcvType${i}`) ||
      (watch(`rcvType${i}`) !== 'N/A' && !watch(`vehicleUsage${i}`)) ||
      !watch(`publicCode${i}`)
    ) {
      return false;
    }
  }
  return true;
};

export const validateInmediateDebit = (notify, watch, payment) => {
  if (!watch(`identificationType${payment?.paymentNumber}`)) {
    notify('Seleccione el tipo de documento de identificación', 'info');
    return false;
  }

  if (!watch(`identification${payment?.paymentNumber}`)) {
    notify('Ingrese el número de identificación', 'info');
    return false;
  }

  if (!watch(`bank${payment?.paymentNumber}`)) {
    notify('Ingrese el banco utilizado en el pago', 'info');
    return false;
  }

  if (!watch(`phone${payment?.paymentNumber}`)) {
    notify('Ingrese el número de telefono', 'info');
    return false;
  }

  return true;
};

export const validateOtpInput = (watch, paymentNumber) => {
  if (
    !watch(`identificationType${paymentNumber}`) ||
    !watch(`identification${paymentNumber}`) ||
    !watch(`bank${paymentNumber}`) ||
    !watch(`phone${paymentNumber}`) ||
    !watch(`requestedOtp${paymentNumber}`)
  ) {
    return true;
  }
  return false;
};

export const validateOtpInputSent = (watch, paymentNumber) => {
  if (
    !watch(`identificationType${paymentNumber}`) ||
    !watch(`identification${paymentNumber}`) ||
    !watch(`bank${paymentNumber}`) ||
    !watch(`phone${paymentNumber}`)
  ) {
    return true;
  }
  return false;
};

export const immediateDebitLastELement = (data) => {
  if (!Array.isArray(data)) return data;
  // Move the object with method === "694454caf9eaf93c15b117fe" to the end
  const targetMethod = '694454caf9eaf93c15b117fe';
  const others = data.filter((item) => item.method !== targetMethod);
  const last = data.filter((item) => item.method === targetMethod);
  return [...others, ...last];
};

export const mergeObjects = (arr) => {
  return arr.reduce((acc, obj) => {
    return { ...acc, ...obj };
  }, {});
};

export const base64ToBlob = (base64String) => {
  // Separar el tipo MIME (metadata) de los datos Base64 reales
  const parts = base64String.split(';base64,');
  const contentType = parts[0].split(':')[1]; // 'image/jpeg' o 'image/png', etc.
  const rawBase64 = parts[1];

  // Decodificar la cadena Base64 a datos binarios puros
  const byteCharacters = atob(rawBase64);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
    const slice = byteCharacters.slice(offset, offset + 1024);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  // Crear el Blob
  return new Blob(byteArrays, { type: contentType });
};

export function mergeObjectValues(inputObject) {
  if (!inputObject || typeof inputObject !== 'object') return {};

  const subObjects = Object.values(inputObject);

  const mergedObject = subObjects.reduce((acc, item) => {
    let obj = item;
    // If the value is an array, take its first element (when it's an object)
    if (Array.isArray(item)) {
      obj =
        item.length > 0 && typeof item[0] === 'object' ? item[0] : undefined;
    }

    if (obj && typeof obj === 'object') {
      return { ...acc, ...obj };
    }

    return acc;
  }, {});

  return mergedObject;
}

export const mapCivilStateToEnum = (input) => {
  if (!input && input !== 0) return civilStateEnum.OTHER;
  const s = String(input).trim().toLowerCase();

  const map = {
    // Soltero/a -> SINGLE
    soltero: civilStateEnum.SINGLE,
    soltera: civilStateEnum.SINGLE,
    'soltero/a': civilStateEnum.SINGLE,
    'soltera/o': civilStateEnum.SINGLE,
    'soltero(a)': civilStateEnum.SINGLE,
    // Casado/a -> MARRIED
    casado: civilStateEnum.MARRIED,
    casada: civilStateEnum.MARRIED,
    // Divorciado/a -> DIVORCED
    divorciado: civilStateEnum.DIVORCED,
    divorciada: civilStateEnum.DIVORCED,
    // Viudo/a -> WIDOW
    viudo: civilStateEnum.WIDOW,
    viuda: civilStateEnum.WIDOW,
    // Otros
    otro: civilStateEnum.OTHER,
  };

  // Busca coincidencia por inclusión (cubrirá mayúsculas, sufijos, etc.)
  for (const key in map) {
    if (s.includes(key)) return map[key];
  }

  // Si no se reconoce, devolver OTHER o puedes devolver null para manejarlo aparte
  return civilStateEnum.OTHER;
};

export const findOptionByFuzzyName = (options, input) => {
  if (!options || !input) return null;
  const normalize = (s) =>
    String(s || '')
      .normalize('NFD') // quitar acentos
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s]/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

  const inorm = normalize(input);

  const inputTokens = inorm.split(' ').filter(Boolean);
  const meaningful = (t) => t && t.length >= 2; // evita tokens de 1 carácter como "c"
  const firstSegment = inorm
    .split('/')
    .map((s) => s.trim())
    .filter(Boolean)[0];

  // 1) exact match on name or _id
  let found = options.find(
    (o) => normalize(o?.name) === inorm || normalize(o?._id) === inorm
  );
  if (found) return found;

  // 1.1) si hay segmentos ("/") intenta con el primero como match exacto
  if (firstSegment && firstSegment !== inorm) {
    const segFound = options.find((o) => normalize(o?.name) === firstSegment);
    if (segFound) return segFound;
  }

  // 2) name included in input or input included in name
  found = options.find((o) => {
    const on = normalize(o?.name);
    return on && on.length >= 3 && (inorm.includes(on) || on.includes(inorm));
  });
  if (found) return found;

  // 3) match por tokens significativos con puntuación (evita priorizar tokens cortos)
  let best = null;
  let bestScore = 0;
  for (const o of options) {
    const oname = normalize(o?.name);
    if (!oname) continue;
    const tokens = oname.split(' ').filter(meaningful);
    if (tokens.length === 0) continue;
    const matched = tokens.filter((t) => inputTokens.includes(t));
    if (matched.length === 0) continue;
    const score = matched.reduce((s, t) => s + t.length, 0);
    if (matched.length === tokens.length) {
      if (!best || score > bestScore) {
        best = o;
        bestScore = score;
      }
      continue;
    }
    if (score > bestScore) {
      best = o;
      bestScore = score;
    }
  }
  if (best) return best;

  // 4) fallback: cualquier token significativo; prioriza el token más largo
  for (const o of options) {
    const oname = normalize(o?.name);
    if (!oname) continue;
    const tokens = oname.split(' ').filter(meaningful);
    const longest = tokens.reduce(
      (m, t) => (t.length > (m?.length || 0) ? t : m),
      null
    );
    if (longest && inorm.includes(longest)) return o;
  }

  return null;
};

export const validateAmount0 = (data, notify) => {
  if ([parseFloat(data?.amountBsS0), parseFloat(data?.amount0)].includes(0)) {
    notify('No se puede realizar un pago con monto 0', 'error');
    return false;
  }
  return true;
};

export const validateIfCanEditPayment = (membership, payment, role) => {
  // console.log('membership:', membership);
  // console.log('role:', role);
  if (
    membership?.membershipStatus === planStatus?.PENDING_FOR_APPROBAL &&
    payment.status !== 'Aprobado' &&
    [
      salesRoles?.SALES_HUNTER,
      salesRoles?.SALES_FARMER,
      salesRoles?.SALES_COUNTER,
      salesRoles?.SALES_KEY_ACCOUNTS
    ]?.includes(role)
  ) {
    return true;
  }

  // Can edit at anytime
  if (
    [
      salesRoles?.SALES_ADMIN,
      salesRoles?.SALES_ADMIN_AUX,
      salesRoles?.SALES_SUPERVISOR,
    ]?.includes(role)
  ) {
    return true;
  } else return false;
};

export const validatePMCashbackData = (method, watch, i) => {
  if (method && PMandTransfers.includes(method?.name)) {
    if (
      !watch(`cashBackphone${i}`) ||
      !watch(`cashBackbank${i}`) ||
      !watch(`cashBackIdentificationType${i}`) ||
      !watch(`cashBackIdentification${i}`)
    ) {
      notify(
        `Debe agregar todos los datos del vuelto para ${capitalize(
          method?.name
        )}`,
        'error'
      );
      return false;
    } else return true;
  } else return true;
};

export const validatIfHasDebt = (membership) => {
  if (membership?.paymentDues[1]?.payment?.length === 0) {
    return false;
  } else {
    const pago = membership?.payments?.find(
      (p) => p?._id === membership?.paymentDues[1]?.payment[0]
    );

    if (
      pago?.status === 'Aprobado' &&
      pago?.totalAmount >= membership?.paymentDues[1]?.amount
    ) {
      return true;
    }
  }
};

export const validateHasDebtOnAnulationOrder = (membership) => {
  return (
    [paymentType?.FINANCIADO, paymentType?.DE_CONTADO].includes(
      membership?.paymentType
    ) && !membership?.pendingToPay
  );
};

export const validateProductsPayment = (transactionType) => {
  if (
    [
      transactionTypes.RCV,
      transactionTypes.RCV_CARD,
      transactionTypes.MEDICAL_CERT,
      transactionTypes.UPGRADE,
    ].includes(transactionType)
  ) {
    return true;
  } else return false;
};

// Normalizes an agency name to compare duplicates: lowercase, no accents,
// no punctuation, single spaces and without the "C.A." / "S.A." suffix
export const normalizeAgencyName = (name) => {
  return String(name ?? '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9ñ\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/(^|\s)(c\s?a|s\s?a)$/, '')
    .trim();
};
